import React, { memo } from 'react'
import { ITagProps, Tag, TAG_SIZE, TAG_STYLE } from 'transfix-ui/components/Tag'

export interface ILoadsAvailableTagProps extends Omit<ITagProps, 'label' | 'tagStyle' | 'size'> {
  loadsAvailableCount: number
}

const LoadsAvailableTag = memo<ILoadsAvailableTagProps>(({ loadsAvailableCount, ...args }) => {
  return (
    <Tag
      label={`${loadsAvailableCount} loads available`}
      tagStyle={loadsAvailableCount > 0 ? TAG_STYLE.info : TAG_STYLE.dark}
      size={TAG_SIZE.xsmall}
      {...args}
    />
  )
})

export default LoadsAvailableTag
